<div class="main disinfection-detail">
    <div class="card">
        <h3 class="title">Disinfection Detail</h3>
        <div class="grid-container">
            <div class="grid-item">
                <label>Program Name:</label>
                <span>{{ disinfectionDetail?.programName || '-' }}</span>
            </div>

            <div class="grid-item">
                <label>Disinfection Type:</label>
                <span>{{ disinfectionDetail?.disinfectionTypeName || '-' }}</span>
            </div>

            <div class="grid-item grid-item--full">
                <label>Instructions:</label>
                <div class="instructions-list">
                    <ng-container
                        *ngIf="
                            disinfectionDetail?.instructions?.length;
                            else noInstructions
                        "
                    >
                        <div
                            class="instruction-item"
                            *ngFor="
                                let instruction of disinfectionDetail.instructions;
                                let i = index
                            "
                        >
                            <span class="instruction-number">{{ i + 1 }}.</span>
                            <span class="instruction-text">{{
                                instruction
                            }}</span>
                        </div>
                    </ng-container>
                    <ng-template #noInstructions>
                        <div class="muted">No instructions available.</div>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="actions">
            <button class="btn btn-secondary" (click)="goBack()">
                <i class="fas fa-arrow-left"></i> Back to List
            </button>
            <button class="btn btn-primary" (click)="editDisinfection()">
                <i class="far fa-edit"></i> Edit
            </button>
        </div>
    </div>
</div>
